import { render, staticRenderFns } from "./commentsstar.vue?vue&type=template&id=1a63ea4f&"
import script from "./commentsstar.vue?vue&type=script&lang=js&"
export * from "./commentsstar.vue?vue&type=script&lang=js&"
import style0 from "./commentsstar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports